import { HttpErrorResponse } from '@angular/common/http'
import { Action, createAction, props } from '@ngrx/store'
import { AuctionBrandingMessages, AuctionsEntity } from './selected-auction.models'
import { LoaderTypeEnum } from 'libs/shared/utils/loader/src/lib/+state/loader.models'
import { Update } from '@ngrx/entity'

// ===== INIT =====
export const initSelectedAuction = createAction(
  '[SelectedAuction/API] Init Selected Auction',
  props<{ urlName: string }>(),
)

export const initPrivateAuctionPusher = createAction(
  '[SelectedAuction/Page] Init Private Auction Pusher',
  props<{ urlName: string }>(),
)

export const initPublicAuctionPusher = createAction('[SelectedAuction/Page] Init Public Auction Pusher')

export const setSelectedAuction = createAction(
  '[SelectedAuction/Page] Set Selected Auction',
  props<{ auction: AuctionsEntity }>(),
)

// ===== SYNC AUCTION =====
export const syncAuction = createAction('[SelectedAuction/API] Sync Auction', props<{ showLoader?: boolean }>())

export const syncAuctionSuccess = createAction(
  '[SelectedAuction/API] Sync Auction Success',
  props<{ auction: AuctionsEntity }>(),
)

export const syncAuctionFailure = createAction(
  '[SelectedAuction/API] Sync Auction Failure',
  props<{ error: HttpErrorResponse; shouldRedirect?: boolean }>(),
)

// ===== UPDATE AUCTION =====
export const updateAuction = createAction(
  '[SelectedAuction/API] Update Auction',
  props<{
    auction: Partial<AuctionsEntity>
    loaderType?: LoaderTypeEnum
    showToast?: boolean
    onSuccess?: () => Action | void
  }>(),
)

export const updateAuctionSuccess = createAction(
  '[SelectedAuction/API] Update Auction Success',
  props<{ auction: AuctionsEntity; showToast?: boolean }>(),
)

export const updateAuctionFailure = createAction(
  '[SelectedAuction/API] Update Selected Auction Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const checkUrlNameUpdate = createAction(
  '[SelectedAuction/API] Check UrlName Update',
  props<{ newUrlName: string; currentUrlName: string }>(),
)

export const updateAuctionForRealtime = createAction(
  '[SelectedAuction/API] Update Auction For Realtime',
  props<{ update: Update<AuctionsEntity> }>(),
)

// ===== AUCTION IMAGES =====
export const openBannerImageUploadDialog = createAction('[SelectedAuction/Page] Open Banner Image Upload Dialog')

export const openLogoImageUploadDialog = createAction(
  '[SelectedAuction/Page] Open Logo Image Upload Dialog',
  props<{ shouldUpdateAuction?: boolean }>(),
)

export const openInvoiceImageUploadDialog = createAction('[SelectedAuction/Page] Open Invoice Image Upload Dialog')

export const updateAuctionBanners = createAction('[SelectedAuction/API] Update Auction Banners')

export const updateAuctionLogo = createAction('[SelectedAuction/API] Update Auction Logo')

export const updateAuctionInvoiceImage = createAction('[SelectedAuction/API] Update Auction Invoice Image')

// ===== AUCTION STATUS =====
export const pauseAuction = createAction('[SelectedAuction/API] Pause Auction')

export const pauseAuctionSuccess = createAction(
  '[SelectedAuction/API] Pause Auction Success',
  props<{ auction: AuctionsEntity }>(),
)

export const pauseAuctionFailure = createAction(
  '[SelectedAuction/API] Pause Auction Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openAuction = createAction('[SelectedAuction/API] Open Auction')

export const openAuctionSuccess = createAction(
  '[SelectedAuction/API] Open Auction Success',
  props<{ auction: AuctionsEntity }>(),
)

export const openAuctionFailure = createAction(
  '[SelectedAuction/API] Open Auction Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const closeAuction = createAction(
  '[SelectedAuction/API] Close Auction',
  props<{ notificationsEnabled: boolean }>(),
)

export const closeAuctionSuccess = createAction(
  '[SelectedAuction/API] Close Auction Success',
  props<{ auction: AuctionsEntity }>(),
)

export const closeAuctionFailure = createAction(
  '[SelectedAuction/API] Close Auction Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openAuctionClosedDialog = createAction(
  '[SelectedAuction/Page] Open Auction Closed Dialog',
  props<{ notificationsEnabled: boolean }>(),
)

// ===== ENABLE/DISABLE AUCTION =====
export const confirmEnableDisableAuction = createAction('[SelectedAuction/Page] Confirm Enable/Disable Auction')

// ===== ARCHIVE AUCTION =====
export const confirmArchiveAuction = createAction('[SelectedAuction/Page] Confirm Archive Auction')

export const archiveAuction = createAction('[SelectedAuction/API] Archive Auction')

export const archiveAuctionSuccess = createAction(
  '[SelectedAuction/API] Archive Auction Success',
  props<{ auction: AuctionsEntity }>(),
)
export const archiveAuctionFailure = createAction(
  '[SelectedAuction/API] Archive Auction Failure',
  props<{ error: HttpErrorResponse }>(),
)

// ===== UI / PREVIEW =====
export const openQRCodeDialog = createAction('[SelectedAuction/Page] Open QR code dialog')

export const loadInvoiceHtml = createAction(
  '[SelectedAuction/API] Load Invoice HTML',
  props<{ urlName: string; onSuccess: (html: string) => void }>(),
)

export const loadInvoiceHtmlSuccess = createAction(
  '[SelectedAuction/API] Load Invoice HTML Success',
  props<{ html: string; onSuccess: (html: string) => void }>(),
)

export const loadInvoiceHtmlFailure = createAction(
  '[SelectedAuction/API] Load Invoice HTML Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadDefaultTermsAndConditions = createAction(
  '[SelectedAuction/API] Load Default Terms and Conditions',
  props<{ onSuccess: (defaultTermsAndConditions: string) => void }>(),
)

export const loadDefaultTermsAndConditionsSuccess = createAction(
  '[SelectedAuction/API] Load Default Terms and Conditions Success',
  props<{ defaultTermsAndConditions: string; onSuccess: (defaultTermsAndConditions: string) => void }>(),
)

export const loadDefaultTermsAndConditionsFailure = createAction(
  '[SelectedAuction/API] Load Default Terms and Conditions Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadDefaultBrandingMessages = createAction(
  '[SelectedAuction/API] Load Default Branding Messages',
  props<{ onSuccess: (result: AuctionBrandingMessages) => void }>(),
)

export const loadDefaultBrandingMessagesSuccess = createAction(
  '[SelectedAuction/API] Load Default Branding Messages Success',
  props<{ defaultBrandingMessages: AuctionBrandingMessages; onSuccess: (result: AuctionBrandingMessages) => void }>(),
)

export const loadDefaultBrandingMessagesFailure = createAction(
  '[SelectedAuction/API] Load Default Branding Messages Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const unsubscribeFromAuctionChannels = createAction('[SelectedAuction/Page] Unsubscribe From Auction Channels')
